/** @format */

import { useRef } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "../components/Layout";
import DocumentsPage from "../pages/documents";
import DocumentsShipmentPage from "../pages/documents/DocumentsShipmentPage";

/** Stable route shell — prevents Documents UI remount on navigation/state updates. */
export default function DocumentsRoute({ userName }) {
  const sidebarToggleRef = useRef(null);

  return (
    <Layout title="Documents" userName={userName} hideMobileHeader onSidebarToggleRef={sidebarToggleRef}>
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        <Routes>
          <Route index element={<DocumentsPage onMenuClick={() => sidebarToggleRef.current?.()} />} />
          <Route
            path="shipment/:listingId"
            element={<DocumentsShipmentPage onMenuClick={() => sidebarToggleRef.current?.()} />}
          />
          <Route path="*" element={<Navigate to="/documents" replace />} />
        </Routes>
      </div>
    </Layout>
  );
}
